/**
 * M2 右侧结构轨(P0-2 §5-3)——「本片结构」竖条,蓝图装载时常驻右栏。
 *
 * 编排前 = 预告(节拍序列,告诉用户「会按这个结构出镜」);
 * 编排后 = 每拍聚合其分镜(镜号 chip,来自拍→镜映射 mapShotsToBeats);
 * 与分镜卡「第 N 拍」标签双向 hover 高亮(hoveredBeat 由页面持有)。
 *
 * 皮肤:语义 token(bg-card/primary/border…),不写死色值。
 */
import { type BlueprintBeat } from "../../model/blueprintStructure";

interface Props {
  beats: BlueprintBeat[];
  /** 每镜所属节拍下标(mapShotsToBeats 产出);空数组=尚未编排(预告态) */
  shotBeatMap: number[];
  hoveredBeat: number | null;
  onHoverBeat: (beat: number | null) => void;
}

export function BlueprintStructureRail({ beats, shotBeatMap, hoveredBeat, onHoverBeat }: Props) {
  if (beats.length === 0) return null;
  const composed = shotBeatMap.length > 0;
  return (
    <div className="rounded-lg border border-border/60 bg-card/40 p-3">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-xs font-semibold text-foreground">本片结构</span>
        <span className="text-2xs text-muted-foreground">
          {composed ? `${beats.length} 拍 · ${shotBeatMap.length} 镜` : "编排后逐拍挂分镜"}
        </span>
      </div>
      <div className="space-y-1.5">
        {beats.map((b, bi) => {
          const shots = shotBeatMap
            .map((beat, shot) => ({ beat, shot }))
            .filter((x) => x.beat === bi)
            .map((x) => x.shot);
          const highlight = hoveredBeat === bi;
          return (
            <button
              key={bi}
              type="button"
              data-beat={bi}
              data-highlight={highlight ? "true" : "false"}
              className={`block w-full rounded-md border px-2 py-1.5 text-left transition-colors ${
                highlight ? "border-primary bg-primary/10" : "border-border/50 bg-background/40"
              }`}
              onMouseEnter={() => onHoverBeat(bi)}
              onMouseLeave={() => onHoverBeat(null)}
              onFocus={() => onHoverBeat(bi)}
              onBlur={() => onHoverBeat(null)}
            >
              <div className="flex items-center gap-1.5">
                <span className="font-mono text-2xs text-muted-foreground">第{bi + 1}拍</span>
                <span className="truncate text-xs text-foreground">{b.label}</span>
                {b.start != null && b.end != null && (
                  <span className="ml-auto shrink-0 font-mono text-2xs text-muted-foreground">
                    {b.start}-{b.end}s
                  </span>
                )}
              </div>
              {composed && shots.length > 0 && (
                <div className="mt-1 flex flex-wrap gap-1">
                  {shots.map((s) => (
                    <span
                      key={s}
                      className="rounded bg-primary/10 px-1.5 py-0.5 font-mono text-2xs text-primary"
                    >
                      镜{s + 1}
                    </span>
                  ))}
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
